// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/weather_forecast_point_selection_state.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/weather_forecast_point_selection_state.proto.
 */
export const file_bfftypes_v1_weather_forecast_point_selection_state: GenFile = /*@__PURE__*/
  fileDesc("CjhiZmZ0eXBlcy92MS93ZWF0aGVyX2ZvcmVjYXN0X3BvaW50X3NlbGVjdGlvbl9zdGF0ZS5wcm90bxILYmZmdHlwZXMudjEqhwIKIldlYXRoZXJGb3JlY2FzdFBvaW50U2VsZWN0aW9uU3RhdGUSNgoyV0VBVEhFUl9GT1JFQ0FTVF9QT0lOVF9TRUxFQ1RJT05fU1RBVEVfVU5TUEVDSUZJRUQQABIzCi9XRUFUSEVSX0ZPUkVDQVNUX1BPSU5UX1NFTEVDVElPTl9TVEFURV9FWFBMSUNJVBABEjgKNFdFQVRIRVJfRk9SRUNBU1RfUE9JTlRfU0VMRUNUSU9OX1NUQVRFX0RFRkFVTFRfVU5TRVQQAhI6CjZXRUFUSEVSX0ZPUkVDQVNUX1BPSU5UX1NFTEVDVElPTl9TVEFURV9ERUZBVUxUX1JFVk9LRUQQA0JCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * WeatherForecastPointSelectionState は「そのエリアで実際に使われている気象予測
 * 地点 (実効地点) が、 なぜその地点になったか」 を表す。 実効地点そのものは
 * backend が解決して返すため、 frontend は地点名とこの state を表示するだけで
 * よい。
 *
 * Wire values mirror backend types.v1.WeatherForecastPointSelectionState but
 * the enum is kept BFF-local so that BFF's contract with the frontend stays
 * decoupled from backend internal types.
 *
 * @generated from enum bfftypes.v1.WeatherForecastPointSelectionState
 */
export enum WeatherForecastPointSelectionState {
  /**
   * @generated from enum value: WEATHER_FORECAST_POINT_SELECTION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 組織が明示選択した地点をそのまま使用している。
   *
   * @generated from enum value: WEATHER_FORECAST_POINT_SELECTION_STATE_EXPLICIT = 1;
   */
  EXPLICIT = 1,

  /**
   * 保存済み地点が無い (未設定) ため代表地点を使用している。
   *
   * @generated from enum value: WEATHER_FORECAST_POINT_SELECTION_STATE_DEFAULT_UNSET = 2;
   */
  DEFAULT_UNSET = 2,

  /**
   * 明示選択が地点マスタ改廃で候補から外れた (失効した) ため代表地点を
   * 使用している。 利用者は選び直しが必要 (AC-WFP-008)。
   *
   * @generated from enum value: WEATHER_FORECAST_POINT_SELECTION_STATE_DEFAULT_REVOKED = 3;
   */
  DEFAULT_REVOKED = 3,
}

/**
 * Describes the enum bfftypes.v1.WeatherForecastPointSelectionState.
 */
export const WeatherForecastPointSelectionStateSchema: GenEnum<WeatherForecastPointSelectionState> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_weather_forecast_point_selection_state, 0);

